import React, { Component } from "react";

import {
  CCard,
  CCardHeader,
  CCardBody,
  CFormGroup,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CSpinner,
  CButton,
  CLabel,
  CSelect,
  CTextarea,
  CInput,
  CCol
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Prompt } from "react-router-dom";
import Select from "react-select";
import { bindActionCreators } from "redux";

import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import ContentComponentActivity from "../../../../components/Content/ContentActivity";
import Form from "../../../../components/Forms/Form";
import {
  alphaNumeric,
  required
} from "../../../../components/Forms/validators";
import Loading from "../../../../components/Loading";
import ModalActivity from "../../../../components/Modal/ModalActivity";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import Uploader from "../../../../components/Uploader/uploader";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import {
  getAbilityName,
  getDisciplineName,
  getDisciplines
} from "../../../../utils/bncc";

const Fields = [];

class CurriculumCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: false,
      image: null,
      // user: {},
      loading: false,
      optionsGroup: [],
      optionsPeriod: [],
      creating: false,
      group_id: null,
      period_id: null,
      submitButton: false,
      // series: [],
      seriesBooks: [],
      segments: [],
      segment: null,
      // segmentName: null,
      modal: false,
      ability: null,
      selectedAbility: null,
      abilities: [
        {
          ability_id: null,
          los: []
        }
      ],
      serie: null,
      serieBook: null,
      discipline: "",
      disciplineName: null,
      observation: "",
      code: "",
      curriculum: {}
    };

    this.formRef = React.createRef();
    this.error = this.error.bind(this);
    this.enviar = this.enviar.bind(this);
    this.atualizar = this.atualizar.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    this.setState({ creating: true });

    axios
      .get(`${URL.api}access/group/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        respGroup => {
          const optionsGroup = [];
          respGroup.data.data.forEach(group => {
            optionsGroup.push({ value: group.id, name: group.name });
          });

          this.setState({ optionsGroup });
        },
        error => {
          this.error("Não foi possível listar os grupos");
        }
      );

    axios
      .get(`${URL.api}classification/ability/filterStructure`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        respSegments => {
          this.setState({ segments: respSegments.data.data });
        },
        error => {
          this.error("Não foi possível listar os segmentos");
        }
      );

    const { id } = this.props.match.params;

    if (id) {
      if (this.props.user.user_roles[0].group_id !== 71) {
        this.setState(
          () => ({
            loading: true
          }),
          () => {
            axios
              .get(`${URL.api}education/curriculum/singleView/${id}`, {
                headers: { authorization: `Bearer ${this.props.user.token}` }
              })
              .then(resp => {
                if (resp.data.success) {
                  axios
                    .get(`${URL.api}education/period/list`, {
                      params: { group_id: resp.data.data.group_id },
                      headers: {
                        authorization: `Bearer ${this.props.user.token}`
                      }
                    })
                    .then(
                      respPeriod => {
                        const optionsPeriod = [];
                        respPeriod.data.data.forEach(period => {
                          optionsPeriod.push({
                            value: period.id,
                            name: period.description
                          });
                        });

                        this.setState({ optionsPeriod });
                      },
                      error => {
                        this.error("Não foi possível listar os períodos");
                      }
                    );

                  this.setState(
                    () => ({
                      curriculum: resp.data.data,
                      code: resp.data.data.code,
                      period_id: resp.data.data.period_id,
                      serie: resp.data.data.serie_id,
                      ability: resp.data.data.ability_id,
                      group_id: resp.data.data.group_id,
                      segment: resp.data.data.segment_id,
                      discipline: resp.data.data.discipline_id,
                      observation: resp.data.data.observation
                    }),
                    () => {
                      this.setState(() => ({
                        edit: true,
                        loading: false
                      }));
                    }
                  );
                }
              });
          }
        );
      } else {
        this.setState(
          () => ({
            loading: true
          }),
          () => {
            axios
              .get(`${URL.api}tool/digitalbooks/singleView/${id}`, {
                headers: { authorization: `Bearer ${this.props.user.token}` }
              })
              .then(resp => {
                this.getSeries(parseInt(resp.data.digitalBooks.observation));
                if (resp.data.success) {
                  const ab = this.tratarAbilities(
                    resp.data.digitalBooks.abilities
                  );
                  this.setState(
                    () => ({
                      disciplineName: resp.data.digitalBooks.code.replace(
                        /\s\d+º\sAno$/,
                        ""
                      ),
                      serieBook: resp.data.digitalBooks.code
                        .split(" ")
                        .slice(1)
                        .join(" "),
                      segment: parseInt(resp.data.digitalBooks.observation),
                      group_id: resp.data.digitalBooks.group_id,
                      image: resp.data.digitalBooks?.photo,
                      period_id: resp.data.digitalBooks.chapter,
                      abilities: ab
                    }),
                    () => {
                      this.setState(() => ({
                        edit: true,
                        loading: false
                      }));
                      // const ab = this.tratarAbilities(
                      //   resp.data.digitalBooks.abilities
                      // );
                    }
                  );
                }
              });
          }
        );
      }
    } else {
      this.setState({ group_id: this.props.general.active_roles.group_id });

      if (this.props.general.active_roles.group_id) {
        axios
          .get(`${URL.api}education/period/list`, {
            params: { group_id: this.props.general.active_roles.group_id },
            headers: { authorization: `Bearer ${this.props.user.token}` }
          })
          .then(respPeriod => {
            const optionsPeriod = [];
            respPeriod.data.data.forEach(
              period => {
                optionsPeriod.push({
                  value: period.id,
                  name: period.description
                });

                this.setState({ optionsPeriod });
              },
              error => {
                this.error("Não foi possível listar os períodos");
              }
            );
          });
      }
    }
  }

  tratarAbilities(obj) {
    if (Array.isArray(obj)) {
      return obj.map(item => this.tratarAbilities(item));
      // eslint-disable-next-line no-else-return
    } else if (typeof obj === "object" && obj !== null) {
      const updatedObj = {};
      for (const key in obj) {
        let newKey = key;
        if (key === "abilities_los") {
          newKey = "los";
        } else if (key === "lo_id") {
          newKey = "id";
        } else if (key === "id") {
          newKey = "id_original";
        } else if (key === "los") {
          updatedObj.name = obj[key][0].name;
        }
        updatedObj[newKey] = this.tratarAbilities(obj[key]);
      }
      return updatedObj;
    }
    return obj;
  }

  enviar(value) {
    // this.setState({ creating: true });
    this.setState({ submitButton: true });

    let obj = {
      code: this.state.code,
      group_id: this.state.group_id,
      period_id: this.state.period_id,
      ability_id: this.state.ability,
      serie_id: this.state.serie,
      observation: this.state.observation
    };

    if (!obj.group_id) {
      toastr.error("Falha", "Selecione um grupo");
      this.setState({ submitButton: false });
      return;
    }

    if (!obj.period_id) {
      toastr.error("Falha", "Selecione um período");
      this.setState({ submitButton: false });
      return;
    }

    if (!obj.ability_id) {
      toastr.error("Falha", "Selecione uma habilidade");
      this.setState({ submitButton: false });
      return;
    }

    if (!obj.serie_id) {
      toastr.error("Falha", "Selecione uma série");
      this.setState({ submitButton: false });
      return;
    }

    if (!obj.code) {
      toastr.error("Falha", "Digite um código");
      this.setState({ submitButton: false });
      return;
    }

    axios
      .post(`${URL.api}education/curriculum/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            this.props.history.push("/curriculum/list");
            this.setState({ creating: false, submitButton: false });
          } else {
            this.error("Não foi possível criar o currículo");
            this.setState({ creating: false, submitButton: false });
          }
        },
        () => {
          this.error("Não foi possível criar o currículo");
          this.setState({ creating: false, submitButton: false });
        }
      );
  }

  atualizar(value) {
    // this.setState({ creating: true });
    this.setState({ submitButton: true });

    let obj = {
      code: this.state.code,
      group_id: this.state.group_id,
      period_id: this.state.period_id,
      ability_id: this.state.ability,
      serie_id: this.state.serie,
      observation: this.state.observation
    };

    if (!obj.group_id) {
      toastr.error("Falha", "Selecione um grupo");
      this.setState({ submitButton: false });
      return;
    }

    if (!obj.period_id) {
      toastr.error("Falha", "Selecione um período");
      this.setState({ submitButton: false });
      return;
    }

    if (!obj.ability_id) {
      toastr.error("Falha", "Selecione uma habilidade");
      this.setState({ submitButton: false });
      return;
    }

    if (!obj.serie_id) {
      toastr.error("Falha", "Selecione uma série");
      this.setState({ submitButton: false });
      return;
    }

    if (!obj.code) {
      toastr.error("Falha", "Digite um código");
      this.setState({ submitButton: false });
      return;
    }

    axios
      .post(`${URL.api}education/curriculum/update/${value.id}`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            this.props.history.push("/curriculum/list");
            this.setState({ creating: false, submitButton: false });
          } else {
            this.error("Não foi possível atualizar o currículo");
            this.setState({ creating: false, submitButton: false });
          }
        },
        () => {
          this.error("Não foi possível atualizar o currículo");
          this.setState({ creating: false, submitButton: false });
        }
      );
  }

  atualizarBook = value => {
    // this.setState({ creating: true });
    this.setState({ submitButton: true });

    const objetoTransformado = this.state.abilities.map(item => ({
      ability_id: item.ability_id,
      los: item.los.map(subItem => subItem.id)
    }));

    let obj = {
      code: this.state.code,
      observation: this.state?.segment.toString(),
      serie_id: this.state.seriesBooks.find(
        serie => serie.name === this.state.serieBook
      )?.id,
      group_id: this.state?.group_id,
      chapter: this.state?.period_id,
      abilities: objetoTransformado,
      photo: this.state?.image
    };

    // if (!obj.group_id) {
    //   toastr.error("Falha", "Selecione um grupo");
    //   this.setState({ submitButton: false });
    //   return;
    // }

    // if (!obj.period_id) {
    //   toastr.error("Falha", "Selecione um período");
    //   this.setState({ submitButton: false });
    //   return;
    // }

    // if (!obj.ability_id) {
    //   toastr.error("Falha", "Selecione uma habilidade");
    //   this.setState({ submitButton: false });
    //   return;
    // }

    // if (!obj.serie_id) {
    //   toastr.error("Falha", "Selecione uma série");
    //   this.setState({ submitButton: false });
    //   return;
    // }

    // if (!obj.code) {
    //   toastr.error("Falha", "Digite um código");
    //   this.setState({ submitButton: false });
    //   return;
    // }
    const { id } = this.props.match.params;
    axios
      .post(`${URL.api}tool/digitalbooks/update/${id}`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            this.props.history.push("/curriculum/list");
            this.setState({ creating: false, submitButton: false });
          } else {
            this.error("Não foi possível atualizar o livro");
            this.setState({ creating: false, submitButton: false });
          }
        },
        () => {
          this.error("Não foi possível atualizar o livro");
          this.setState({ creating: false, submitButton: false });
        }
      );
  };

  enviarBook = value => {
    this.setState({ creating: true });
    this.setState({ submitButton: true });

    // habilities.
    const objetoTransformado = this.state.abilities.map(item => ({
      ability_id: item.ability_id,
      los: item.los.map(subItem => subItem.id)
    }));

    let obj = {
      code: `${this.state.disciplineName} ${this.state.serieBook}`,
      observation: this.state.segment.toString(),
      serie_id: this.state.seriesBooks.find(
        serie => serie.name === this.state.serieBook
      ).id,
      group_id: this.state.group_id,
      chapter: this.state.period_id,
      abilities: objetoTransformado,
      photo: this.state?.image
    };

    // if (!obj.group_id) {
    //   toastr.error("Falha", "Selecione um grupo");
    //   this.setState({ submitButton: false });
    //   return;
    // }

    // if (!obj.period_id) {
    //   toastr.error("Falha", "Selecione um período");
    //   this.setState({ submitButton: false });
    //   return;
    // }

    // if (!obj.ability_id) {
    //   toastr.error("Falha", "Selecione uma habilidade");
    //   this.setState({ submitButton: false });
    //   return;
    // }

    // if (!obj.serie_id) {
    //   toastr.error("Falha", "Selecione uma série");
    //   this.setState({ submitButton: false });
    //   return;
    // }

    // if (!obj.code) {
    //   toastr.error("Falha", "Digite um código");
    //   this.setState({ submitButton: false });
    //   return;
    // }

    axios
      .post(`${URL.api}tool/digitalbooks/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            this.props.history.push("/curriculum/list");
            this.setState({ creating: false, submitButton: false });
          } else {
            this.error("Não foi possível criar o livro");
            this.setState({ creating: false, submitButton: false });
          }
        },
        () => {
          this.error("Não foi possível criar o livro");
          this.setState({ creating: false, submitButton: false });
        }
      );
  };

  getSeries = segmentId => {
    axios
      .get(`${URL.api}classification/serie/listSerieFilter/${segmentId}`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          let aux = resp.data.data.map(resp => resp);
          this.setState({
            seriesBooks: aux
            // serieBook: null
          });
        },
        error => {
          this.error("Não foi possível listar os períodos");
        }
      );
  };

  done(uploads) {
    this.setState({
      image: URL.img + uploads[0]
    });
  }

  changeSegment(e, disciplines) {
    const segment = parseInt(e.target.value);

    let segmentName = this.state.segments.filter(e => e.id === segment);

    this.setState(
      {
        segment,
        // series: null,
        ability: null,
        // module: null,
        discipline: "",
        // segmentName: segment_name[0]?.name,
        serieBook: "Série",
        disciplineName: null
      },
      () => {
        this.getSeries(segment);
      }
    );
  }

  changeDiscipline(e, disciplines) {
    const discipline = parseInt(e.target.value);

    let disciplineName = disciplines.filter(e => e.id === discipline);

    this.setState({
      disciplineName: disciplineName[0].name,
      discipline,
      // series: null,
      ability: null,
      // module: null,
      abilities: [
        {
          ability_id: null,
          los: []
        }
      ]
    });
  }

  changeGroup(e) {
    const group = parseInt(e.target.value);

    this.setState({
      group_id: parseInt(e.target.value),
      // region_id: null,
      // school_id: null,
      period_id: null,
      optionsPeriod: []
    });

    if (!group) return;

    axios
      .get(`${URL.api}education/period/list`, {
        params: { group_id: group },
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        respPeriod => {
          const optionsPeriod = [];
          respPeriod.data.data.forEach(period => {
            optionsPeriod.push({ value: period.id, name: period.description });
          });

          this.setState({ optionsPeriod });
        },
        error => {
          this.error("Não foi possível listar os períodos");
        }
      );
  }

  toggleModal = () => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      modal: !this.state.modal
    });
  };

  getContent = content => {
    let auxAbilities = [];
    for (let x = 0; x < this.state.abilities.length; x++) {
      auxAbilities.push({
        ability_id: this.state.abilities[x].ability_id,
        los: this.state.abilities[x].los
      });
    }
    auxAbilities[this.state.selectedAbility].los = content.list;
    this.setState({
      abilities: auxAbilities,
      modal: false
    });
  };

  addAbility = () => {
    let auxAbilities = [];
    for (let x = 0; x < this.state.abilities.length; x++) {
      auxAbilities.push({
        ability_id: this.state.abilities[x].ability_id,
        los: this.state.abilities[x].los
      });
    }
    auxAbilities.push({
      ability_id: null,
      los: []
    });
    this.setState({
      abilities: auxAbilities
    });
  };

  removeAbility = index => {
    let auxAbilities = [];
    for (let x = 0; x < this.state.abilities.length; x++) {
      auxAbilities.push({
        ability_id: this.state.abilities[x].ability_id,
        los: this.state.abilities[x].los
      });
    }
    auxAbilities.splice(index, 1);
    this.setState({
      abilities: auxAbilities
    });
  };

  render() {
    const segments =
      this.state.segments.filter(
        segment =>
          segment.disciplines.filter(
            discipline =>
              !!discipline.objectives.find(
                objective => objective.abilities.length > 0
              )
          ).length > 0
      ) || [];

    const disciplines =
      segments
        .find(segment => segment.id === this.state.segment)
        ?.disciplines.filter(
          discipline =>
            !!discipline.objectives.find(
              objective => objective.abilities.length > 0
            )
        ) || [];

    const objectives =
      disciplines.find(
        discipline =>
          discipline.id === this.state.discipline ||
          discipline.name === this.state.disciplineName
      )?.objectives || [];

    // if (disciplines.length > 0) {
    //   this.setState({
    //     discipline: disciplines.find(
    //       dis => dis.name === this.state.disciplineName
    //     )?.id
    //   });
    // }

    const abilities = objectives
      .map(objective => ({
        label: objective.description,
        id: objective.id,
        options: objective.abilities.map(ability => ({
          label: `(${ability.code}) ${ability.description}`,
          code: ability.code,
          value: ability.id,
          objective: objective.id,
          series: ability.series,
          thematic_unit_name: objective.thematic_unit_name,
          objective_name: objective.description
        }))
      }))
      .filter(objective => objective.options.length > 0);

    const ability =
      abilities
        .reduce((acc, val) => [...acc, ...val.options], [])
        .find(ability => ability.value === this.state.ability) || null;

    let getAbilityProps = id => {
      let abilityProps =
        abilities
          .reduce((acc, val) => [...acc, ...val.options], [])
          .find(ability => ability.value === id) || null;
      return abilityProps;
    };

    const getLosNames = (los, abilityIndex) => {
      if (los.length === 0) {
        return "Nenhuma aula foi vinculada a esta habilidade.";
      }

      return los.map((losItem, losIndex) => (
        <div
          key={losIndex}
          style={{
            // alignItems: "center",
            display: "flex",
            flexWrap: "wrap",
            position: "relative",
            marginRight: "20px"
          }}
        >
          {losItem.name}
          <CButton
            color="danger"
            className="d-flex ml-2 justify-content-center align-items-center"
            onClick={() => removeLos(abilityIndex, losIndex)}
            style={{
              backgroundColor: "danger",
              border: "none",
              borderRadius: "50%",
              width: "20px",
              height: "20px",
              // display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "absolute",
              top: "-10px",
              right: "-15px"
            }}
          >
            <span className="justify-content-center align-items-center">
              <i className="fa fa-remove"></i>
            </span>
          </CButton>
          {losIndex === los.length - 1 ? "." : ", "}
        </div>
      ));
    };

    const removeLos = (abilityIndex, losIndex) => {
      // eslint-disable-next-line react/no-access-state-in-setstate
      const updatedAbilities = [...this.state.abilities];
      updatedAbilities[abilityIndex].los.splice(losIndex, 1);
      this.setState({
        abilities: updatedAbilities
      });
    };

    const series =
      ability?.series
        .filter(serie => serie.segment_id === this.state.segment)
        .map(item => ({
          label: item.name,
          value: item.id,
          order: item.order
        })) || [];

    const seriesBooks =
      this.state.seriesBooks?.map(item => ({
        label: item.name,
        value: item.id,
        order: item.order
      })) || [];

    const serie =
      series.find(serie => serie.value === this.state.serie) || null;

    // const serieBook =
    //   seriesBooks.find(serie => serie.label === this.state.serieBook) || null;

    return (
      <>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/curriculum/list", to: "/curriculum/list" }]}
        />
        <Prompt
          when={!this.state.creating}
          message="Os dados do formulário ainda não foram salvos. Tem certeza de que deseja sair desta página?"
        />
        {this.state.loading ? (
          <Loading />
        ) : this.props.user.user_roles[0].group_id === 71 ? (
          <CCard>
            <CCardHeader className="d-flex align-items-center">
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <h4 className="card-title mb-1">
                  {this.state.edit ? "Editar Currículo" : "Criar Currículo"}
                </h4>
                <div className="small text-muted">
                  {this.state.edit
                    ? "Edite o currículo selecionado"
                    : "Crie um novo currículo"}
                </div>
              </div>
              <CButton
                color="primary"
                className="d-flex justify-content-center align-items-center"
                onClick={() => this.formRef.current.submit()}
                disabled={!this.state.creating}
              >
                <>
                  <span style={this.state.submitButton ? { opacity: 0 } : null}>
                    <i className="fa fa-cloud-upload mr-2"></i>Salvar
                  </span>
                  {this.state.submitButton && (
                    <CSpinner
                      size="sm"
                      color="white"
                      style={{ position: "absolute" }}
                    />
                  )}
                </>
              </CButton>
            </CCardHeader>
            <CCardBody>
              <Form
                avatar
                fields={Fields}
                ref={this.formRef}
                history={this.props.history}
                onSubmit={
                  this.state.edit ? this.atualizarBook : this.enviarBook
                }
                initialValues={this.state.curriculum}
                edit={this.state.edit}
              />
              <CFormGroup>
                <CLabel>Grupo</CLabel>
                <CInputGroup>
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-text-width"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CSelect
                    className="flex-1"
                    value={this.state.group_id}
                    onChange={e => this.changeGroup(e)}
                    disabled={this.props.general.active_roles.group_id !== null}
                  >
                    <option value={null}>Grupo</option>
                    {this.state.optionsGroup.map(group => (
                      <option value={group.value} key={group.value}>
                        {group.name}
                      </option>
                    ))}
                  </CSelect>
                </CInputGroup>
              </CFormGroup>
              <div className="d-flex flex-1 justify-content-between">
                <CFormGroup className="flex-1">
                  <CLabel>Segmento</CLabel>
                  <CInputGroup className="flex-nowrap">
                    <CInputGroupPrepend>
                      <CInputGroupText>
                        <i className="fa fa-text-width"></i>
                      </CInputGroupText>
                    </CInputGroupPrepend>
                    <CSelect
                      placeholder="Segmento"
                      value={this.state.segment}
                      onChange={e => this.changeSegment(e)}
                    >
                      <option>Segmento</option>
                      {segments.map(segment => (
                        <option key={segment.id} value={segment.id}>
                          {segment.name}
                        </option>
                      ))}
                    </CSelect>
                  </CInputGroup>
                </CFormGroup>
                <CFormGroup className="flex-1 ml-5">
                  <CLabel>Série</CLabel>
                  <CInputGroup className="flex-nowrap">
                    <CInputGroupPrepend>
                      <CInputGroupText>
                        <i className="fa fa-text-width"></i>
                      </CInputGroupText>
                    </CInputGroupPrepend>

                    <CSelect
                      placeholder="Série"
                      noOptionsMessage={() => "Nada encontrado"}
                      value={this.state.serieBook}
                      onChange={e => {
                        this.setState({ serieBook: e.target.value });
                      }}
                    >
                      <option>Série</option>
                      {seriesBooks.map(series => (
                        <option key={series.id} value={series.id}>
                          {series.label}
                        </option>
                      ))}
                    </CSelect>
                  </CInputGroup>
                </CFormGroup>
              </div>
              <div className="d-flex flex-1 justify-content-between">
                <CFormGroup className="flex-1">
                  <CLabel>Disciplina</CLabel>
                  <CInputGroup className="flex-nowrap">
                    <CInputGroupPrepend>
                      <CInputGroupText>
                        <i className="fa fa-text-width"></i>
                      </CInputGroupText>
                    </CInputGroupPrepend>
                    <CSelect
                      placeholder="Disciplina"
                      value={
                        this.state.disciplineName
                          ? disciplines.find(
                              dis => dis.name === this.state.disciplineName
                            )?.id
                          : this.state.discipline
                      }
                      onChange={e => this.changeDiscipline(e, disciplines)}
                    >
                      <option>Disciplina</option>
                      {disciplines.map(discipline => (
                        <option key={discipline.id} value={discipline.id}>
                          {discipline.name}
                        </option>
                      ))}
                    </CSelect>
                  </CInputGroup>
                </CFormGroup>
                <CFormGroup className="flex-1 ml-5">
                  <CLabel>Capítulo</CLabel>
                  <CInputGroup>
                    <CInputGroupPrepend>
                      <CInputGroupText>
                        <i className="fa fa-text-width"></i>
                      </CInputGroupText>
                    </CInputGroupPrepend>
                    <CSelect
                      value={[this.state.period_id]}
                      onChange={e =>
                        this.setState({
                          period_id: parseInt(e.target.value)
                        })
                      }
                    >
                      <option value={null}>Capítulo</option>
                      {/* {this.state.optionChapter.map(period => (
                        <option value={period} key={period}>
                          {period}
                        </option>
                      ))} */}
                      <option value="1">1°</option>
                      <option value="2">2°</option>
                      <option value="3">3°</option>
                      <option value="4">4°</option>
                    </CSelect>
                  </CInputGroup>
                </CFormGroup>
              </div>

              <CLabel className="d-flex d-flex align-items-center">
                {getAbilityName(this.state.segment)}
                <CButton
                  color="primary"
                  className="d-flex ml-2 justify-content-center align-items-center"
                  onClick={() => this.addAbility()}
                  disabled={!this.state.creating}
                >
                  <span className="justify-content-center align-items-center">
                    <i className="fa fa-plus"></i>
                  </span>
                </CButton>
              </CLabel>
              {this.state.abilities.map((item, index) => (
                <>
                  <CFormGroup className="d-flex justify-content-center align-items-center">
                    <CInputGroup className="flex-nowrap">
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <i className="fa fa-text-width"></i>
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <Select
                        placeholder={getAbilityName(this.state.segment)}
                        name={getAbilityName(this.state.segment)}
                        options={abilities}
                        value={getAbilityProps(item.ability_id)}
                        noOptionsMessage={() => "Nada encontrado"}
                        className="basic-multi-select flex-1"
                        classNamePrefix="select"
                        onChange={e => {
                          // eslint-disable-next-line react/no-access-state-in-setstate
                          let auxAbilities = [...this.state.abilities];
                          auxAbilities[index] = {
                            ability_id: e.value,
                            los: []
                          };
                          this.setState({
                            abilities: auxAbilities,
                            selectedAbility: index,
                            serie: null,
                            code: e.code,
                            modal: true
                          });
                        }}
                      />
                    </CInputGroup>
                    <CButton
                      color="primary"
                      className="d-flex ml-2 justify-content-center align-items-center"
                      onClick={() =>
                        this.setState({ selectedAbility: index, modal: true })
                      }
                      disabled={!item.ability_id}
                    >
                      <span className="justify-content-center align-items-center">
                        <i className="fa fa-pencil"></i>
                      </span>
                    </CButton>
                    {index ? (
                      <CButton
                        color="danger"
                        className="d-flex ml-2 justify-content-center align-items-center"
                        onClick={() => this.removeAbility(index)}
                        disabled={!this.state.creating}
                      >
                        <span className="justify-content-center align-items-center">
                          <i className="fa fa-remove"></i>
                        </span>
                      </CButton>
                    ) : (
                      <></>
                    )}
                  </CFormGroup>
                  {item.ability_id && (
                    <div
                      className="pl-3"
                      style={{ borderLeft: "4px solid var(--light)" }}
                    >
                      <CFormGroup>
                        <CLabel>Objetivo</CLabel>
                        <div className="text-muted">
                          {getAbilityProps(item.ability_id)?.objective_name}
                        </div>
                      </CFormGroup>
                      <CFormGroup>
                        <CLabel>Unidade Temática</CLabel>
                        <div className="text-muted">
                          {getAbilityProps(item.ability_id)?.thematic_unit_name}
                        </div>
                      </CFormGroup>
                      <CFormGroup>
                        <CLabel>Aulas Relacionadas</CLabel>
                        <div
                          className="text-muted"
                          style={{ display: "flex", flexWrap: "wrap" }}
                        >
                          {getLosNames(item.los, index)}
                        </div>
                      </CFormGroup>
                    </div>
                  )}
                </>
              ))}

              {this.state.period_id === 1 && (
                <CFormGroup>
                  <CLabel>Capa do Livro</CLabel>
                  <CCol>
                    {this.state.image === null ? (
                      <Uploader
                        type="lo"
                        maxFiles={1}
                        acceptedFileTypes={["image/*"]}
                        allowMultiple
                        labelIdle='Arraste e solte sua imagem ou <span class="filepond--label-action">procure</span>'
                        done={uploads => this.done(uploads)}
                      />
                    ) : (
                      <div className="d-flex align-items-center">
                        {this.state.image && (
                          <img
                            src={this.state.image}
                            style={{ maxHeight: "60px" }}
                            className="mr-3"
                          />
                        )}
                        <CButton
                          color="primary"
                          onClick={() => this.setState({ image: null })}
                        >
                          {this.state.image ? "Alterar" : "Adicionar"} Imagem
                        </CButton>
                      </div>
                    )}
                  </CCol>
                </CFormGroup>
              )}

              {/* <CFormGroup>
                <CLabel>Observação</CLabel>
                <CTextarea
                  rows={4}
                  name="observation"
                  value={this.state.observation}
                  onChange={e => this.setState({ observation: e.target.value })}
                  placeholder="Observação"
                />
              </CFormGroup> */}
            </CCardBody>
          </CCard>
        ) : (
          <CCard>
            <CCardHeader className="d-flex align-items-center">
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <h4 className="card-title mb-1">
                  {this.state.edit ? "Editar Currículo" : "Criar Currículo"}
                </h4>
                <div className="small text-muted">
                  {this.state.edit
                    ? "Edite o currículo selecionado"
                    : "Crie um novo currículo"}
                </div>
              </div>
              <CButton
                color="primary"
                className="d-flex justify-content-center align-items-center"
                onClick={() => this.formRef.current.submit()}
                disabled={!this.state.creating}
              >
                <>
                  <span style={this.state.submitButton ? { opacity: 0 } : null}>
                    <i className="fa fa-cloud-upload mr-2"></i>Salvar
                  </span>
                  {this.state.submitButton && (
                    <CSpinner
                      size="sm"
                      color="white"
                      style={{ position: "absolute" }}
                    />
                  )}
                </>
              </CButton>
            </CCardHeader>
            <CCardBody>
              <Form
                avatar
                fields={Fields}
                ref={this.formRef}
                history={this.props.history}
                onSubmit={this.state.edit ? this.atualizar : this.enviar}
                initialValues={this.state.curriculum}
                edit={this.state.edit}
              />
              <CFormGroup>
                <CLabel>Grupo</CLabel>
                <CInputGroup>
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-text-width"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CSelect
                    className="flex-1"
                    value={this.state.group_id}
                    onChange={e => this.changeGroup(e)}
                    disabled={this.props.general.active_roles.group_id !== null}
                  >
                    <option value={null}>Grupo</option>
                    {this.state.optionsGroup.map(group => (
                      <option value={group.value} key={group.value}>
                        {group.name}
                      </option>
                    ))}
                  </CSelect>
                </CInputGroup>
              </CFormGroup>
              <CFormGroup>
                <CLabel>Período</CLabel>
                <CInputGroup>
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-text-width"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CSelect
                    className="flex-1"
                    value={this.state.period_id}
                    onChange={e =>
                      this.setState({
                        period_id: parseInt(e.target.value)
                      })
                    }
                  >
                    <option value={null}>Período</option>
                    {this.state.optionsPeriod.map(period => (
                      <option value={period.value} key={period.value}>
                        {period.name}
                      </option>
                    ))}
                  </CSelect>
                </CInputGroup>
              </CFormGroup>
              <CFormGroup>
                <CLabel>Segmento</CLabel>
                <CInputGroup className="flex-nowrap">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-text-width"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CSelect
                    placeholder="Segmento"
                    value={this.state.segment}
                    onChange={e => this.changeSegment(e)}
                  >
                    <option>Segmento</option>
                    {segments.map(segment => (
                      <option key={segment.id} value={segment.id}>
                        {segment.name}
                      </option>
                    ))}
                  </CSelect>
                </CInputGroup>
              </CFormGroup>
              <CFormGroup>
                <CLabel>{getDisciplineName(this.state.segment)}</CLabel>
                <CInputGroup className="flex-nowrap">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-text-width"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CSelect
                    placeholder={getDisciplineName(this.state.segment)}
                    value={this.state.discipline}
                    onChange={e => this.changeDiscipline(e)}
                  >
                    <option>{getDisciplineName(this.state.segment)}</option>
                    {getDisciplines(this.state.segment, disciplines).map(
                      discipline => (
                        <option key={discipline.id} value={discipline.id}>
                          {discipline.name}
                        </option>
                      )
                    )}
                  </CSelect>
                </CInputGroup>
              </CFormGroup>
              <CFormGroup>
                <CLabel>{getAbilityName(this.state.segment)}</CLabel>
                <CInputGroup className="flex-nowrap">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-text-width"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <Select
                    placeholder={getAbilityName(this.state.segment)}
                    name={getAbilityName(this.state.segment)}
                    options={abilities}
                    value={ability}
                    noOptionsMessage={() => "Nada encontrado"}
                    className="basic-multi-select flex-1"
                    classNamePrefix="select"
                    onChange={e =>
                      this.setState({
                        ability: e.value,
                        serie: null,
                        code: e.code
                      })
                    }
                  />
                </CInputGroup>
              </CFormGroup>
              {ability && (
                <div
                  className="pl-3"
                  style={{ borderLeft: "4px solid var(--light)" }}
                >
                  <CFormGroup>
                    <CLabel>Objetivo</CLabel>
                    <div className="text-muted">{ability.objective_name}</div>
                  </CFormGroup>
                  <CFormGroup>
                    <CLabel>Unidade Temática</CLabel>
                    <div className="text-muted">
                      {ability.thematic_unit_name}
                    </div>
                  </CFormGroup>
                </div>
              )}
              <CFormGroup>
                <CLabel>Série</CLabel>
                <CInputGroup className="flex-nowrap">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-text-width"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <Select
                    placeholder="Série"
                    name="Série"
                    noOptionsMessage={() => "Nada encontrado"}
                    options={series}
                    value={serie}
                    className="basic-multi-select flex-1"
                    classNamePrefix="select"
                    onChange={e => this.setState({ serie: e.value })}
                  />
                </CInputGroup>
              </CFormGroup>
              <CFormGroup>
                <CLabel>Código Padronizado</CLabel>
                <CInputGroup className="flex-nowrap">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-text-width"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CInput
                    name="code"
                    value={this.state.code}
                    onChange={e => this.setState({ code: e.target.value })}
                    placeholder="Código Padronizado"
                  />
                </CInputGroup>
              </CFormGroup>
              <CFormGroup>
                <CLabel>Observação</CLabel>
                <CTextarea
                  rows={4}
                  name="observation"
                  value={this.state.observation}
                  onChange={e => this.setState({ observation: e.target.value })}
                  placeholder="Observação"
                />
              </CFormGroup>
            </CCardBody>
          </CCard>
        )}
        <ModalActivity
          toggleModal={this.toggleModal}
          modalState={this.state.modal}
          title="Selecione as Aulas relacionadas"
          className=" educandus modalActivity"
          backdrop="static"
          size="xl"
          noFooter
        >
          <ContentComponentActivity
            type={1}
            discipline={this.state.discipline}
            typeName="Aula"
            activity
            typeColor="danger"
            typeIcon="graduation-cap"
            getContent={content => this.getContent(content)}
            currentRoute={this.props.currentRoute}
          />
        </ModalActivity>
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ setObj }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CurriculumCreate);
